export default __webpack_public_path__ + "static/logo-c3ad3262aa7560f47ff210da157fcc77.svg";